export const modals = {
	confirmProductToggle: {
		deactivateProduct: "Désactiver le produit",
		activeProduct: "Activer le produit",
		confirmModalDescription:
			"Voulez-vous {{action}} les produits montables qu'il compose ?",
	},
	confirmToggle: {
		deactivateProduct: "Désactiver le produit",
		activateProduct: "Activer le produit",
		toggleProducts: "Basculer seulement ce produit",
	},
	deleteCategory: {
		title: "Supprimer la catégorie",
		cancelButton: "Annuler",
		moveAndDeleteButton: "Déplacer les produits et supprimer la catégorie",
		deleteButton: "Supprimer la catégorie",
		newCategoryLabel: "Nouvelle catégorie",
		selectNewCategoryPlaceholder: "Sélectionner une nouvelle catégorie",
		categoryDeletedSuccess:
			'La catégorie "{{categoryName}}" a été supprimée avec succès.',
		categoryDeletedAndProductsMovedSuccess:
			'La catégorie "{{categoryName}}" a été supprimée et ses produits ont été ' +
			'déplacés vers "{{newCategoryName}}".',
		categoryWithProductsDescription:
			"Cette catégorie a <strong>{{productCount}} produit lié</0>. " +
			"Avant de supprimer la catégorie, vous devez déplacer les produits vers une autre catégorie",
		categoryWithProductsDescription_plural:
			"Cette catégorie a <strong>{{productCount}} produits liés</0>. " +
			"Avant de supprimer la catégorie, vous devez déplacer les produits vers une autre catégorie",
		confirmDeleteCategoryDescription:
			"Êtes-vous sûr de vouloir supprimer cette catégorie ? <strong>Cette action ne peut pas être annulée.</0>",
	},
	massEdit: {
		title: "Édition en masse des produits",
		completeButton: "Terminer",
		cancelButton: "Annuler",
		comingSoon: "Bientôt : flux d'édition en masse",
		selectedCount: "{{count}} {{unit}} sélectionné",
		selectedCount_plural: "{{count}} {{unit}} sélectionnés",
		selectedProduct: "Produit sélectionné",
		selectedProducts: "Produits sélectionnés",
		instruction: 'Cliquez sur "Terminer" pour procéder à la suppression de la catégorie.',
		fields: {
			category: {
				label: "Catégorie",
				placeholder: "Choisir la nouvelle catégorie",
			},
			type: {
				label: "Type",
				placeholder: "Choisir un nouveau type",
			},
			fiscalGroup: {
				label: "Groupe fiscal",
				placeholder: "Choisir un nouveau groupe fiscal",
			},
			fiscalProfile: {
				label: "Profil fiscal",
				placeholder: "Choisir un nouveau profil fiscal",
			},
		},
	},
	duplicateProductDrawer: {
		title: "Dupliquer le produit montable",
		stepTitles: {
			duplicateProduct: "Dupliquer le Produit",
			selectProducts: "Sélectionner les Produits",
		},
		duplicationChoice: {
			createNewProduct: {
				title: "Créer un nouveau produit montable",
				description: "Dupliquer le montable pour l'utiliser dans un nouveau produit",
			},
			batchDuplicate: {
				title: "Importer le duplicata en lot",
				description: "Importer l'étape montable vers des produits déjà créés",
			},
		},
		actions: {
			cancel: "Annuler",
			back: "Retour",
			duplicate: "Dupliquer le montable",
			addProducts: "Ajouter des produits",
			comingSoon: "Cette fonctionnalité sera implémentée prochainement",
			noMountableData: "Aucune donnée montable à dupliquer",
		},
		productSelection: {
			label: "Sélectionnez les produits qui recevront le montable :",
			placeholder: "Sélectionner les produits...",
			selectedProducts: "Produits sélectionnés",
			emptyState: {
				title: "Aucun produit sélectionné",
				description: "Ajoutez les produits auxquels vous voulez dupliquer le montable",
			},
			successMessage:
				'Les paramètres de "{{productName}}" ont été appliqués à {{count}} produit avec succès.',
			successMessage_plural:
				'Les paramètres de "{{productName}}" ont été appliqués à {{count}} produits avec succès.',
		},
	},
	removeProduct: {
		cancel: "Annuler",
		remove: "Retirer",
		confirmRemoveMessage:
			'Êtes-vous sûr de vouloir retirer le produit <strong>"{{productName}}"</strong> de cet emplacement ?',
	},
	removeProducts: {
		title: "Retirer les produits sélectionnés {{count}}",
		cancelButton: "Annuler",
		removeButton: "Retirer le produit",
		removeButton_plural: "Retirer {{count}} produits",
		description:
			"Les {{count}} produits sélectionnés seront retirés de cet emplacement (vous " +
			"pouvez toujours les voir au niveau org).",
		confirmQuestion: "Êtes-vous sûr de vouloir continuer ?",
		removeSuccess: "Produit retiré avec succès",
		removeSuccess_plural: "{{count}} produits retirés avec succès",
		removeError: "Échec du retrait de {{count}} produit",
		removeError_plural: "Échec du retrait de {{count}} produits",
	},
	exitMassEditMode: {
		title: "Quitter le mode d'édition en masse ?",
		description:
			"Vous avez des produits sélectionnés. En naviguant vers une autre catégorie, la sélection sera perdue.",
		confirmButton: "Oui, quitter",
		cancelButton: "Annuler",
	},
};
